import React from 'react';

export const IconBlacklist = () => {
  return (
    <span className="icon-svg IconBlacklist">
      <svg
        className="svg-icon"
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
        }}
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M652.8 1024H153.6C68.9024 1024 0 955.0976 0 870.4V153.6C0 68.9024 68.9024 0 153.6 0h537.6c84.6976 0 153.6 68.9024 153.6 153.6v196.224a25.6 25.6 0 0 1-51.2 0V153.6c0-56.4608-45.9392-102.4-102.4-102.4H153.6c-56.4608 0-102.4 45.9392-102.4 102.4v716.8c0 56.4608 45.9392 102.4 102.4 102.4h499.2a25.6 25.6 0 0 1 0 51.2z"
          fill="#333333"
        />
        <path
          d="M384 243.2H153.6a25.6 25.6 0 0 1 0-51.2h230.4a25.6 25.6 0 0 1 0 51.2zM204.8 499.2h-51.2a25.6 25.6 0 0 1 0-51.2h51.2a25.6 25.6 0 0 1 0 51.2zM652.8 1024c-204.6848 0-371.2-166.528-371.2-371.2 0-204.6848 166.5152-371.2 371.2-371.2 204.672 0 371.2 166.5152 371.2 371.2 0 204.672-166.528 371.2-371.2 371.2z m0-691.2c-176.448 0-320 143.552-320 320s143.552 320 320 320 320-143.552 320-320-143.552-320-320-320z"
          fill="#333333"
        />
        <path
          d="M897.1776 922.7776a25.4976 25.4976 0 0 1-18.0992-7.5008L390.3232 426.5216a25.6 25.6 0 1 1 36.1984-36.1984l488.7552 488.7552a25.6 25.6 0 0 1-18.0992 43.6992z"
          fill="#333333"
        />
      </svg>
    </span>
  );
};
